/**
 * Component added to entities that shall expand to host connector position.
 */
class RequireSizeAdjustmentComponent {
    constructor(host, hostConnector) {
        this.host = host;
        this.hostConnector = hostConnector;
        this.typeId = 3005;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq(_other) {
        return false;
    }
}
RequireSizeAdjustmentComponent.id = 3005;
export default RequireSizeAdjustmentComponent;
//# sourceMappingURL=RequireSizeAdjustmentComponent.js.map